import React from 'react';
import DashboardCard from '../shared/DashboardCard';
import EmptyState from '../shared/EmptyState';
import styles from '../../../../styles/DashboardV2.module.css';

interface TeamActivity {
    id: string;
    agentName: string;
    action: string;
    createdAt: string;
}

interface RecentTeamActivityWidgetProps {
    activities: TeamActivity[];
    loading?: boolean;
}

const getTimeAgo = (dateStr: string): string => {
    const now = new Date();
    const then = new Date(dateStr);
    const diffMs = now.getTime() - then.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffMins < 1)   return 'Just now';
    if (diffMins < 60)  return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays === 1) return 'Yesterday';
    return `${diffDays}d ago`;
};

const RecentTeamActivityWidget: React.FC<RecentTeamActivityWidgetProps> = ({
    activities,
    loading,
}) => {
    const top15 = activities.slice(0, 15);

    return (
        <DashboardCard
            title="Recent Team Activity"
            loading={loading}
        >
            {top15.length === 0 ? (
                <EmptyState icon="📝" message="No recent team activity." />
            ) : (
                <div className={styles.activityFeed}>
                    {top15.map(item => (
                        <div key={item.id} className={styles.activityItem}>
                            <div className={styles.activityDot} />
                            <div className={styles.activityContent}>
                                <div className={styles.activityText}>
                                    <strong>{item.agentName}</strong> {item.action}
                                </div>
                                <div className={styles.activityTime}>{getTimeAgo(item.createdAt)}</div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </DashboardCard>
    );
};

export default RecentTeamActivityWidget;
